export enum OrderResponseErrorAccentKeys {
  DOCUMENT_OUTSIDE_ALLOWED_PERIOD = "core.documentation_area.response.errors.document_outside_allowed_period",
  PAYSLIP_NOT_MATCHES_EMPLOYEE_ID = "core.documentation_area.response.errors.payslips.not_matches_employee_id",
  MODEL_NOT_REQUESTED = "core.documentation_area.response.errors.document_not_requested",
  UNIDENTIFIED_FILE = "core.documentation_area.response.errors.unidentified_file",
  MODEL_EXPIRED_VALIDATION_DATA = "core.documentation_area.response.errors.expired_validation_data",
  MODEL_NOT_MATCHES_ID_NUMBERS = "core.documentation_area.response.errors.docs_ai.not_matches_id_numbers",
  MODEL_NOT_MATCHES_ID_NUMBERS_FOR_COMPANY = "core.documentation_area.response.errors.docs_ai.not_matches_id_numbers_for_companies",
  PAYSLIP_MISSING_ESSENTIAL_DATA = "core.documentation_area.response.errors.missing_essential_data",
  IDENTITY_VERIFICATION_FILE_DISCARDED = "core.documentation_area.response.errors.idv_file_discarded",
  IDENTITY_VERIFICATION_REQUEST_GENERIC = "core.documentation_area.response.errors.idv_request_generic",
  IDENTITY_VERIFICATION_REQUEST_WRONG_DOCUMENTS = "core.documentation_area.response.errors.idv_request_wrong_documents",
  IDENTITY_VERIFICATION_REQUEST_RESULT_INVALID = "core.documentation_area.response.errors.idv_request_result_invalid",
  IDENTITY_VERIFICATION_RESULT_DOES_NOT_MATCH_ID_NUMBER = "core.documentation_area.response.errors.idv_result_does_not_match_id_number",
  INVALIDATED_BY_CUSTOMER = "core.documentation_area.response.errors.invalidated_by_customer",
  VALIDATED_BY_CUSTOMER = "core.documentation_area.response.errors.validated_by_customer",
  ORDER_CANCELLED_BY_CUSTOMER = "core.documentation_area.response.errors.order_cancelled_by_customer",
  MODEL_ADMINISTRATION_UNAVAILABLE = "core.documentation_area.response.errors.model_administration_unavailable",
  MODEL_GENERATED_TOO_LONG_AGO = "core.documentation_area.response.errors.model_generated_too_long_ago",
  ORDER_MODEL_ALREADY_HAS_RESPONSE = "core.documentation_area.response.errors.order_model_already_has_response",
  MODEL_GENERIC = "core.documentation_area.response.errors.model_generic",
}

export function orderResponseErrorToAccentKey(key: string): OrderResponseErrorAccentKeys {
  switch (key) {
    case "DOCUMENT_OUTSIDE_ALLOWED_PERIOD":
      return OrderResponseErrorAccentKeys.DOCUMENT_OUTSIDE_ALLOWED_PERIOD;
    case "PAYSLIP_NOT_MATCHES_EMPLOYEE_ID":
      return OrderResponseErrorAccentKeys.PAYSLIP_NOT_MATCHES_EMPLOYEE_ID;
    case "UNIDENTIFIED_DOCUMENT":
      return OrderResponseErrorAccentKeys.UNIDENTIFIED_FILE;
    case "MODEL_EXPIRED_VALIDATION_DATA":
      return OrderResponseErrorAccentKeys.MODEL_EXPIRED_VALIDATION_DATA;
    case "MODEL_NOT_REQUESTED":
      return OrderResponseErrorAccentKeys.MODEL_NOT_REQUESTED;
    case "MODEL_NOT_MATCHES_ID_NUMBERS":
      return OrderResponseErrorAccentKeys.MODEL_NOT_MATCHES_ID_NUMBERS;
    case "MODEL_NOT_MATCHES_ID_NUMBERS_FOR_COMPANY":
      return OrderResponseErrorAccentKeys.MODEL_NOT_MATCHES_ID_NUMBERS_FOR_COMPANY;
    case "PAYSLIP_MISSING_ESSENTIAL_DATA":
      return OrderResponseErrorAccentKeys.PAYSLIP_MISSING_ESSENTIAL_DATA;
    case "IDENTITY_VERIFICATION_FILE_REQUEST_DISCARDED":
      return OrderResponseErrorAccentKeys.IDENTITY_VERIFICATION_FILE_DISCARDED;
    case "IDENTITY_VERIFICATION_REQUEST_GENERIC":
      return OrderResponseErrorAccentKeys.IDENTITY_VERIFICATION_REQUEST_GENERIC;
    case "IDENTITY_VERIFICATION_REQUEST_WRONG_DOCUMENTS":
      return OrderResponseErrorAccentKeys.IDENTITY_VERIFICATION_REQUEST_WRONG_DOCUMENTS;
    case "IDENTITY_VERIFICATION_REQUEST_RESULT_INVALID":
      return OrderResponseErrorAccentKeys.IDENTITY_VERIFICATION_REQUEST_RESULT_INVALID;
    case "IDENTITY_VERIFICATION_RESULT_DOES_NOT_MATCH_ID_NUMBER":
      return OrderResponseErrorAccentKeys.IDENTITY_VERIFICATION_RESULT_DOES_NOT_MATCH_ID_NUMBER;
    case "INVALIDATED_BY_CUSTOMER":
      return OrderResponseErrorAccentKeys.INVALIDATED_BY_CUSTOMER;
    case "VALIDATED_BY_CUSTOMER":
      return OrderResponseErrorAccentKeys.VALIDATED_BY_CUSTOMER;
    case "ORDER_CANCELLED_BY_CUSTOMER":
      return OrderResponseErrorAccentKeys.ORDER_CANCELLED_BY_CUSTOMER;
    case "MODEL_ADMINISTRATION_UNAVAILABLE":
      return OrderResponseErrorAccentKeys.MODEL_ADMINISTRATION_UNAVAILABLE;
    case "MODEL_GENERATED_TOO_LONG_AGO":
      return OrderResponseErrorAccentKeys.MODEL_GENERATED_TOO_LONG_AGO;
    case "ORDER_MODEL_ALREADY_HAS_RESPONSE":
      return OrderResponseErrorAccentKeys.ORDER_MODEL_ALREADY_HAS_RESPONSE;
    case "MODEL_GENERIC":
      return OrderResponseErrorAccentKeys.MODEL_GENERIC;
    default:
      return key as OrderResponseErrorAccentKeys;
  }
}
